import React, { useEffect, useState } from "react";
import EndMove from "./EndMove";
import BeforeAgreement from "./BeforeAgreement";
import { checkCircleImage } from "../../../../../../assets";
import { invokeApi } from "../../../../../../bl_libs/invokeApi";
import { Alert } from "@material-ui/lab";
import { CircularProgress } from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import {
  getMovers,
  time_convert,
} from "../../../../../../ui_libs/Functions/functions";
import { useSnakbar } from "../../../../../../Context/Context-Snakbar/ContextSnackbar";
import { v4 as uuidv4 } from "uuid";

function MoveInProgress(props) {
  const { requestData, fetchRequestDetails } = props;
  const { showErrorSnak } = useSnakbar();
  const { truck_array, agreement_status, request } = requestData;
  const {
    customer_budget,
    recommend_amount,
    id,
    final_amount,
    total_discount,
    schedule_time,
    net_distance,
    request_type,
    rate_method,
    start_window_from,
    start_window_to,
    s_time,
  } = requestData.request;
  const { first_name, last_name, user_model } =
    requestData.get_foreman_of_company;

  const [isAgree, setIsAgree] = useState(false);
  const [isDocumentAvailable, setIsDocumentAvailable] = useState("");

  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [errMessage, setErrMessage] = React.useState("");
  const [extraItemsList, setExtraItemList] = React.useState([]);
  const [extraItems, setExtraItems] = useState([
    // { local_id: uuidv4(), item: "", price: "", custom: false },
  ]);

  const [endTime, setEndTime] = useState({
    move_time: {
      hours: 0,
      minutes: 0,
    },
    drive_time: {
      hours: 0,
      minutes: 0,
    },
    break_time: {
      hours: 0,
      minutes: 0,
    },
    card_time: {
      hours: 0,
      minutes: 0,
    },
    cash_time: {
      hours: 0,
      minutes: 0,
    },
    payment_method: "Cash",
    cash_amount: "0",
    card_amount: "0",
    additional_cash_amount: "",
    additional_card_amount: "",
    discount_amount: "",
    discount_type: "flat",
  });

  const getInMinutes = (time) => {
    const minutes = parseInt(time.hours) * 60 + parseInt(time.minutes);
    return minutes.toString();
  };

  const calculateFinalAmount = () => {
    if (rate_method === "Hourly") {
      const time =
        Number(getInMinutes(endTime.move_time)) +
        Number(getInMinutes(endTime.drive_time));
      const cash_rate = Number(requestData.request.cash_payment_rate);
      const card_rate = Number(requestData.request.card_payment_rate);

      const cash_price = (cash_rate * time) / 60;
      const card_price = (card_rate * time) / 60;

      if (endTime.payment_method === "Cash") return Number(cash_price);
      if (endTime.payment_method === "Card") return Number(card_price);
      return Number(endTime.cash_amount) + Number(endTime.card_amount);
    }

    if (rate_method === "Flat") {
      return Number(endTime.cash_amount) + Number(endTime.card_amount);
    }
  };

  const handleChangeInAdditionalSplit = (type, value) => {
    let total = 0;
    const list = extraItems.map((item) => {
      if (item.item && item.price) {
        total = total + Number(item.price) * Number(item.quantity);
      }
    });

    if (type === "cash") {
      if (value > total) {
        setEndTime({
          ...endTime,
          additional_cash_amount: total,
          additional_card_amount: 0,
        });
        return;
      }
      setEndTime({
        ...endTime,
        additional_cash_amount: value,
        additional_card_amount: total - value,
      });
      return;
    }
    if (type === "card") {
      if (value > total) {
        setEndTime({
          ...endTime,
          additional_card_amount: total,
          additional_cash_amount: 0,
        });
        return;
      }
      setEndTime({
        ...endTime,
        additional_card_amount: value,
        additional_cash_amount: total - value,
      });
      return;
    }
  };

  const calculateRemainingAmount = (method, value) => {
    let amount = value;
    const time = Number(getInMinutes(endTime.move_time));
    const cash_rate = Number(requestData.request.cash_payment_rate);
    const card_rate = Number(requestData.request.card_payment_rate);

    const cash_price = (cash_rate * time) / 60;
    const card_price = (card_rate * time) / 60;

    console.log(amount, "amount");
    console.log(card_price, "card_price");
    console.log(cash_price, "cash_price");

    if (method === "Cash") {
      const ratio = card_price / cash_price;
      let remains = cash_price - amount;
      remains = remains * ratio;

      if (amount > cash_price) {
        setEndTime({
          ...endTime,
          cash_amount: cash_price.toFixed(2),
          card_amount: 0,
        });

        return;
      }

      setEndTime({
        ...endTime,
        cash_amount: amount ? amount.toFixed(2) : 0,
        card_amount: remains.toFixed(2),
      });
    }

    if (method === "Card") {
      const ratio = cash_price / card_price;
      let remains = card_price - amount;
      remains = remains * ratio;

      if (amount > card_price) {
        setEndTime({
          ...endTime,
          card_amount: card_price.toFixed(2),
          cash_amount: 0,
        });

        return;
      }

      setEndTime({
        ...endTime,
        card_amount: amount ? amount.toFixed(2) : 0,
        cash_amount: remains.toFixed(2),
      });
    }
  };

  const getTimeFromMinutes = (minutes) => {
    var hours = parseInt(minutes) / 60;
    var r_hours = Math.floor(hours);
    var minutes = (hours - r_hours) * 60;
    var r_minutes = Math.round(minutes);

    return { hours: r_hours, minutes: r_minutes };
  };

  const calculateRemainingTime = (method, type, value) => {
    const cash_rate = Number(requestData.request.cash_payment_rate);
    const card_rate = Number(requestData.request.card_payment_rate);
    let total_move_time =
      Number(getInMinutes(endTime.move_time)) +
      Number(getInMinutes(endTime.drive_time));

    console.log(total_move_time, "total_move_time");
    let minutes;
    console.log(value, "value");
    if (method === "Cash") {
      if (type === "HH") {
        minutes = Number(value) * 60 + Number(endTime.cash_time.minutes);
      } else {
        minutes = Number(endTime.cash_time.hours) * 60 + Number(value);
      }
    } else {
      if (type === "HH") {
        minutes = Number(value) * 60 + Number(endTime.card_time.minutes);
      } else {
        minutes = Number(endTime.card_time.hours) * 60 + Number(value);
      }
    }

    if (minutes > total_move_time) {
      return;
    }

    let remaining_minutes = total_move_time - minutes;

    let selected_time = getTimeFromMinutes(minutes);
    let remaining_time = getTimeFromMinutes(remaining_minutes);

    let key = type === "HH" ? "hours" : "minutes";
    if (method === "Card") {
      const card_price = (card_rate * minutes) / 60;
      const cash_price = (cash_rate * remaining_minutes) / 60;
      setEndTime({
        ...endTime,
        card_time: {
          hours: selected_time.hours,
          minutes: selected_time.minutes,
        },
        cash_time: {
          hours: remaining_time.hours,
          ...endTime,
          card_time: {
            hours: selected_time.hours,
            minutes: selected_time.minutes,
          },
          cash_time: {
            hours: remaining_time.hours,
            minutes: remaining_time.minutes,
          },
          cash_amount: cash_price,
          card_amount: card_price,
          minutes: remaining_time.minutes,
        },
        cash_amount: cash_price,
        card_amount: card_price,
      });
    }

    if (method === "Cash") {
      const cash_price = (cash_rate * minutes) / 60;
      const card_price = (card_rate * remaining_minutes) / 60;
      setEndTime({
        ...endTime,

        cash_time: {
          hours: selected_time.hours,
          minutes: selected_time.minutes,
        },
        card_time: {
          hours: remaining_time.hours,
          minutes: remaining_time.minutes,
        },
        cash_amount: cash_price,
        card_amount: card_price,
      });
    }
  };

  const getTotalTime = () => {
    const drive_time = Number(getInMinutes(endTime.drive_time)) / 60;
    const move_time = Number(getInMinutes(endTime.move_time)) / 60;
    const total_time = drive_time + move_time;
    return total_time;
  };

  const additionalItemsCost = () => {
    let total = 0;
    let is_ok = true;
    const items_list = extraItems.map((item) => {
      if (!item.item.label || !Number(item.quantity) || !Number(item.price)) {
        is_ok = false;
      }
      if (item.item.label && item.price) {
        total = total + Number(item.price) * Number(item.quantity);
      }
      return {
        _id: `${item.item.id ? item.item.id : ""}`,
        name: item.item.label,
        unit_price: `${item.price}`,
        quantity: `${item.quantity}`,
        currency: "USD",
      };
    });
    return { total, is_ok, items_list };
  };

  const MakeSecondDocument = () => {
    const { total, is_ok, items_list } = additionalItemsCost();

    console.log(items_list, "items_list");
    if (!is_ok) {
      showErrorSnak(
        'Please fill the all fields of "Additional Item"  or remove it.'
      );
      return;
    }
    document.getElementById("end-move-close").click();
    setIsLoadingBtn(true);
    let requestObj = {
      path: "/app_api/get_second_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
      move_time: getInMinutes(endTime.move_time),
      drive_time: getInMinutes(endTime.drive_time),
      break_time: getInMinutes(endTime.break_time),
      payment_method: endTime.payment_method,
      extra_items_array: items_list,
      total_time: `${getTotalTime()}`,
      total_discount: `${endTime.discount_amount}`,
      discount_type: `${endTime.discount_type}`,
      final_amount: request_type
        ? `${calculateFinalAmount() + total - Number(endTime.discount_amount)}`
        : `${final_amount}`,
      cash_amount: `${
        endTime.payment_method === "Cash"
          ? `${calculateFinalAmount() + total}`
          : `${
              Number(endTime.cash_amount) +
              Number(endTime.additional_cash_amount)
            }`
          ? `${
              Number(endTime.cash_amount) +
              Number(endTime.additional_cash_amount)
            }`
          : "0"
      }`,
      card_amount: `${
        endTime.payment_method === "Card"
          ? `${calculateFinalAmount() + total}`
          : `${
              Number(endTime.card_amount) +
              Number(endTime.additional_card_amount)
            }`
          ? `${
              Number(endTime.card_amount) +
              Number(endTime.additional_card_amount)
            }`
          : "0"
      }`,
    };
    requestObj["postData"] = postData;
    console.log(postData, "POST DATA");
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        props.history.push({
          pathname: "/salesman/salesman-requests/sign-agreement/" + id,
          data: { postData: postData, resData: res.getrequestdocument },
        });
      } else {
        setErrMessage(res.message);
        setIsLoadingBtn(false);
      }
    });
  };

  const handleEndMove = () => {
    setIsLoadingBtn(true);
    let requestObj = {
      path: "/api/foreman/end_move",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    requestObj["postData"] = postData;
    console.log(postData, "POST DATA");
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        fetchRequestDetails();
      } else {
        setErrMessage(res.message);
        setIsLoadingBtn(false);
      }
    });
  };

  const checkForDocument = () => {
    let requestObj = {
      path: "/app_api/check_company_state_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    requestObj["postData"] = postData;

    invokeApi(requestObj).then((res) => {
      console.log(res, "checkForDocument");
      if (res.code === 200) {
        setIsDocumentAvailable(res.status);
      } else {
        showErrorSnak(res.message);
      }
    });
  };

  const handleBeginMove = () => {
    let requestObj = {
      path: "/api/foreman/begin_move",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    requestObj["postData"] = postData;

    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        fetchRequestDetails();
      } else {
        showErrorSnak(res.message);
      }
    });
  };

  const fetchExtraList = () => {
    let requestObj = {
      path: "/api/customer/get_item_by_category_id",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      type: "2",
      category_id: "",
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res.data.items, "Extra items");
      if (res.code === 200) {
        const list = res.data.items.map((item) => {
          return {
            label: item.name,
            value: item.name,
            ...item,
          };
        });

        setExtraItemList(list);
      } else {
        showErrorSnak(res.message);
      }
    });
  };

  useEffect(() => {
    fetchExtraList();
  }, []);
  useEffect(() => {
    if (rate_method === "Flat") {
      setEndTime({
        ...endTime,
        cash_amount: "",
        card_amount: "",
        discount_amount: "",
      });
      return;
    }
    calculateRemainingTime(
      "Cash",
      "MM",
      Number(getInMinutes(endTime.move_time)) +
        Number(getInMinutes(endTime.drive_time))
    );
  }, [endTime.payment_method]);

  useEffect(() => {
    handleChangeInAdditionalSplit("card", 0);
  }, [extraItems]);

  useEffect(() => {
    setEndTime({
      ...endTime,
      payment_method: "Cash",
      card_amount: "",
      cash_amount: "",
      cash_time: {
        hours: "",
        minutes: "",
      },
      card_time: {
        hours: "",
        minutes: "",
      },
      discount_amount: "",
    });
  }, [endTime.move_time, endTime.drive_time]);

  useEffect(() => {
    checkForDocument();
  }, []);
  return (
    <>
      <div className="rounded-box">
        <div className="heading-wrapper black-bg text-center">
          <h6 className="text-white">Request #{id}</h6>
        </div>
        {errMessage && (
          <Alert variant="filled" severity="error">
            {errMessage}
          </Alert>
        )}
        {!isDocumentAvailable && isDocumentAvailable !== "" && (
          <Alert variant="filled" severity="warning">
            Agreement document is not available against your state. Please
            contact admin.
          </Alert>
        )}
        <div className="request-left-box p-3 p-sm-4">
          <div className="row">
            <div className="col-8">
              <div className="request-staus small-font-size">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                </svg>{" "}
                Tracking location
              </div>
            </div>
            <div className="col-4 text-right">
              {request.sale_man_request_status && (
                <span className="custom-chip">Against You</span>
              )}
            </div>
          </div>
          <div className="bid-form-wrapper pt-3">
            <div className="row small-font-size">
              <div className="col-6 text-left dark-grey-color">Start time:</div>
              <div className="col-6 text-right black-color">
                {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                {s_time &&
                  s_time !== "8AM - 12PM Morning" &&
                  s_time !== "12PM - 5PM Evening" &&
                  s_time !== "Entire day" &&
                  `${time_convert(
                    s_time.split("-")[0].trim()
                  )} to ${time_convert(s_time.split("-")[1].trim())}`}
                {s_time &&
                  (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") &&
                  `${s_time}`}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Movers:</div>
              <div className="col-6 text-right black-color">
                {getMovers(requestData)}
              </div>
            </div>

            {request_type && (
              <>
                {/* Hourly rate details */}
                {requestData.request.rate_method === "Hourly" && (
                  <>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Cash Hour Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.cash_payment_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Card Hour Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.card_payment_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Minimum Hours:
                      </div>
                      <div className="col-6 text-right black-color">
                        {requestData.request.minimum_hours}
                      </div>
                    </div>
                  </>
                )}
                {/* Flat rate details */}
                {requestData.request.rate_method === "Flat" && (
                  <>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Cash Flat Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.cash_min_flat_rate} - $
                        {requestData.request.cash_max_flat_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Card Flat Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.card_min_flat_rate} - $
                        {requestData.request.card_max_flat_rate}
                      </div>
                    </div>
                  </>
                )}
                {requestData.request.customer_phone_number && (
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Customer Phone #:
                    </div>
                    <div className="col-6 text-right black-color">
                      {requestData.request.customer_phone_number}
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Truck Name:</div>
              <div className="col-6 text-right light-red-color">
                {truck_array.map((truck, i) => {
                  return (
                    truck.name + (i === truck_array.length - 1 ? "" : ", ")
                  );
                })}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Foreman name:
              </div>
              <div className="col-6 text-right light-red-color">
                {first_name + " " + last_name}
              </div>
            </div>

            {(!request_type || agreement_status === 3) &&
              total_discount &&
              total_discount !== "0" && (
                <>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Price:
                    </div>
                    <div className="col-6 text-right black-color">
                      ${Number(final_amount) + Number(total_discount)}
                    </div>
                  </div>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Discount:
                    </div>
                    <div className="col-6 text-right light-red-color">
                      ${total_discount}
                    </div>
                  </div>
                </>
              )}

            {(!request_type || agreement_status === 3) && (
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">
                  Final Price:
                </div>
                <div className="col-6 text-right black-color">
                  ${final_amount}
                </div>
              </div>
            )}

            {/* <div className="row text-center pt-3">
              <div className="col-12 small-font-size">
                To end the move client should read and agree with the policy
              </div>
            </div> */}
            {(agreement_status === 0 || agreement_status === 1) && (
              <>
                <div className="row pt-3">
                  <div className="col-8">
                    <div className="request-staus sub-title">
                      Agreement policy (Start Move)
                    </div>
                  </div>
                  {agreement_status === 1 ? (
                    <div className="col-4 text-right">
                      <img src={checkCircleImage} />
                    </div>
                  ) : (
                    <div className="col-4 text-right">
                      <Link
                        className="small-text-bold red-color add-new-btn"
                        style={
                          isDocumentAvailable
                            ? {}
                            : { color: "#ecebed", cursor: "default" }
                        }
                        to={"/salesman/salesman-requests/sign-agreement/" + id}
                      >
                        <span>Show</span>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="row pt-4 pb-3">
                  <div className="col-12">
                    {agreement_status === 1 ? (
                      isLoadingBtn ? (
                        <div className="text-center pt-1" style={{ margin: 2 }}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <button
                          className="custom-buton custom-buton-large w-100"
                          onClick={handleBeginMove}
                        >
                          Begin Move
                        </button>
                      )
                    ) : (
                      <button
                        className="custom-buton custom-buton-large w-100 disabled"
                        disabled
                      >
                        Begin Move
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
            {(agreement_status === 2 || agreement_status === 3) && (
              <>
                <div className="row pt-3">
                  <div className="col-8">
                    <div className="request-staus sub-title">
                      Agreement policy (Finish Move)
                    </div>
                  </div>
                  {agreement_status === 3 ? (
                    <div className="col-4 text-right">
                      <img src={checkCircleImage} />
                    </div>
                  ) : (
                    <div className="col-4 text-right">
                      <Link
                        className="small-text-bold red-color add-new-btn"
                        style={
                          isDocumentAvailable
                            ? {}
                            : { color: "#ecebed", cursor: "default" }
                        }
                        data-toggle="modal"
                        data-target="#start-move"
                      >
                        <span>Show</span>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="row pt-4 pb-3">
                  <div className="col-12">
                    {agreement_status === 3 ? (
                      isLoadingBtn ? (
                        <div className="text-center pt-1" style={{ margin: 2 }}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <button
                          className="custom-buton custom-buton-large w-100"
                          onClick={handleEndMove}
                        >
                          End Move
                        </button>
                      )
                    ) : (
                      <button
                        className="custom-buton custom-buton-large w-100 disabled"
                        data-toggle="modal"
                        data-target="#start-move"
                        disabled
                      >
                        End Move{" "}
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <BeforeAgreement />
      <EndMove
        requestData={requestData}
        endTime={endTime}
        setEndTime={setEndTime}
        MakeSecondDocument={MakeSecondDocument}
        net_distance={net_distance}
        request_type={request_type}
        calculateRemainingAmount={calculateRemainingAmount}
        calculateRemainingTime={calculateRemainingTime}
        extraItemsList={extraItemsList}
        extraItems={extraItems}
        setExtraItems={setExtraItems}
        calculateFinalAmount={calculateFinalAmount}
        handleChangeInAdditionalSplit={handleChangeInAdditionalSplit}
      />
    </>
  );
}

export default withRouter(MoveInProgress);
